const { mapping } = require("../mappings/index");

function getPushEventData({ product = "", page = "", event = "", data = {} }) {
    const productMap = mapping[product] || {};
    const eventPropertiesHandler = productMap[page];
    if (typeof eventPropertiesHandler !== "function") {
        throw new Error(`No event handler found for event ${product}_${page}_${event}`)
    }
    return {
        product,
        page,
        event,
        data: eventPropertiesHandler(product, event, data),
    };
}

function getProductPage(path) {
    const splitpath = path.split("/")
    const filterPath = splitpath.filter(data => data)
    return {
        product: filterPath[0],
        page: filterPath[1]
    }

}

module.exports = { getPushEventData, getProductPage }